<div class="page-wrapper">
  <div class="content">
    <div class="img-content">
      <div
        class="img-parent"
        role="button"
        (click)="userPreferences = 'Parent'"
      >
        <p class="text">Parent</p>
        <div class="check-input">
          <input
            type="radio"
            value="Parent"
            name="type"
            [(ngModel)]="userPreferences"
            id="parent"
          />
          <label for="parent"></label>
        </div>
      </div>
      <div
        class="img-school"
        role="button"
        (click)="userPreferences = 'School'"
      >
        <p class="text">School</p>
        <div class="check-input">
          <input
            type="radio"
            value="School"
            [(ngModel)]="userPreferences"
            name="type"
            id="school"
          />
          <label for="school" id="scss"></label>
        </div>
      </div>
    </div>
    <div class="btn-content">
      <button
        class="btn-custom btn-width"
        (click)="submit()"
        [disabled]="!userPreferences"
      >
        {{ 'shared.next' | translate }}
      </button>
    </div>
  </div>
</div>
